export default "__VITE_ASSET__83e331a5__"